import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectableGrid');

    return {
        NO_ITEMS: t('noItems'),
        NO_MORE_ITEMS: t('noMoreItems')
    };
};

export default useTranslation;
